<template>
  <table class="table mb-0 table-striped">
    <thead class="bg-light">
      <tr>
        <th scope="col" class="border-0">#</th>
        <th scope="col" class="border-0">Nome</th>
        <th scope="col" class="text-center border-0">Status</th>
        <th scope="col" class="text-center border-0">Order</th>
        <th scope="col" class="text-center border-0">Url</th>
        <th scope="col" class="text-center border-0">Opções</th>
      </tr>
    </thead>
    <tbody>
      <tr v-for="(row, index) in banners" :key="index">
        <td>{{ row.id }}</td>
        <td class="td-4 link">
          <router-link :to="{ name: 'admin-banner-edit', params: { bannerId: row.id} }" >{{ row.name }}</router-link>
        </td>
        <td class="td-2">
          <d-select v-model="row.status_id" @change="changedBanner(row)">
            <option :value="status.id" v-for="status in statuses" :key="status.value">{{ status.name }}</option>
          </d-select>
        </td>
        <td class="text-center td-1">
          <input v-model="row.order" class="form-control" @blur="changedBanner(row)"/>
        </td>
        <td class="td-3">
          <a :href="row.url" target="_blank">{{ row.url }}</a>
        </td>
        <td class="text-center td-2">
          <banner-buttons :banner="row"></banner-buttons>
        </td>
      </tr>
      <tr v-if="banners.length === 0">
        <td colspan="6" class="no-content">Ainda não tem nenhum banner cadastrado.</td>
      </tr>
    </tbody>
    <confirmation-modal
      :cancel="close"
      :confirm="deleteRow"
      title="Confirme exclusão de banner"
      message="Tem certeza que deseja excluir este banner?"/>
  </table>
</template>

<script>
import { mapActions } from 'vuex';
import Events from '_utils/events';
import ConfirmationModal from '_shared/ConfirmationModal.vue';
import BannerService from '_services/rest/modules/banner';
import BannerButtons from './BannerButtons.vue';
import BannerDelete from './BannerDelete';
import { _DELETE_BANNER_ } from './BannerModel';

export default {
  name: 'banner-table',
  mixins: [BannerDelete],
  components: {
    BannerButtons,
    ConfirmationModal,
  },
  props: {
    banners: {
      type: Array,
    },
  },
  computed: {
    statuses() {
      const { status } = this.$store.state.puzzle;
      if (status.length) {
        return status;
      }
      return [];
    },
  },
  data() {
    return {
      selectBanner: null,
      editable: false,
    };
  },
  methods: {
    ...mapActions([
      'activeAlert',
      'getStatusList',
    ]),
    changedBanner(row) {
      BannerService.save(row)
        .then(() => {
          Events.$emit('update:pagination', 1);
          this.activeAlert({ message: 'Banner alterado com sucesso', theme: 'success' });
        });
    },
    getOptions() {
      if (this.statuses.length === 0) {
        this.getStatusList();
      }
    },
  },
  mounted() {
    this.getOptions();
    Events.$on(_DELETE_BANNER_, banner => {
      this.selectBanner = banner.id;
    });
  },
};
</script>

<style lang="scss" scoped>
@import '~_scss/overrides';

.link {
  color: $primary;
  span {
    cursor: pointer;
  }
}

.td {
  &-1 {
    width: 70px;
  }
  &-2 {
    min-width: 100px;
  }
  &-3 {
    min-width: 140px;
  }
  &-4 {
    min-width: 200px;
  }
}
</style>
